export enum BidvBankTransferServiceKeys {
  GET_TRANSFER_STATUS = 'BIDV_GET_TRANSFER_STATUS',
  LOOKUP_ACCOUNT = 'BIDV_LOOKUP_ACCOUNT',
  LIST_DOMESTIC_BANKS = 'BIDV_LIST_DOMESTIC_BANKS',
  GET_BANK_TRANSFER_WHITELIST = 'BIDV_GET_BANK_TRANSFER_WHITELIST',
  GET_TRANSFER_DEST_WHITELIST = 'BIDV_GET_TRANSFER_DEST_WHITELIST',
}
